import React, { Component } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import CardTitle from './CardTitle';
import CardBody from './CardBody';
import CardFooter from './CardFooter';
import CardCourse from './CardCourse/CardCourse';
import CardList from './CardList/CardList';
import CardActions from './CardActions/CardActions';
import CardInfoBlock from './CardInfoBlock/CardInfoBlock';
import CardActionsPanel from './CardActions/CardActionsPanel';
import CardProfile from './CardProfile/CardProfile';

class Card extends Component {
  render() {
    const {
      type,
      children,
      uniqueID,
      clickable,
      isStackedCard,
      style,
    } = this.props;

    const clickableClass = clickable ? ' Card__clickable' : '';
    const stackClass = isStackedCard ? 'Card_stack-card' : '';

    return (
      <div className="Card" style={style}>
        <div
          className={classnames('Card_container', type, clickableClass, stackClass)}
          id={uniqueID && uniqueID}
        >
          {children}
        </div>
      </div>
    );
  }
}

Card.Title = CardTitle;
Card.Body = CardBody;
Card.Footer = CardFooter;
Card.Course = CardCourse;
Card.List = CardList;
Card.Actions = CardActions;
Card.ActionsPanel = CardActionsPanel;
Card.InfoBlock = CardInfoBlock;
Card.Profile = CardProfile;

Card.propTypes = {
  type: PropTypes.string,
  children: PropTypes.any,
  uniqueID: PropTypes.string,
  clickable: PropTypes.bool,
  isStackedCard: PropTypes.bool,
  style: PropTypes.object,
};

Card.defaultProps = {
  type: null,
  uniqueID: null,
  clickable: null,
  children: null,
  isStackedCard: false,
  style: {},
};

export default Card;
